import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Plus, Pencil, Trash2 } from 'lucide-react'
import { supabase } from '../supabaseClient'
import ConfirmModal from '../components-admin/ConfirmModal'

export default function CasesListPageAdmin() {
  const [cases, setCases] = useState([])
  const [loading, setLoading] = useState(true)
  const [deleteId, setDeleteId] = useState(null)

  const fetchCases = async () => {
    setLoading(true)
    const { data, error } = await supabase.from('cases').select('*').order('created_at', { ascending: false })
    if (!error) setCases(data || [])
    setLoading(false)
  }

  const handleDelete = async () => {
    if (!deleteId) return
    await supabase.from('cases').delete().eq('id', deleteId)
    setDeleteId(null)
    fetchCases()
  }

  useEffect(() => { fetchCases() }, [])

  const statusBadge = (status) => {
    if (status === 'published') return 'bg-emerald-50 text-emerald-700 border-emerald-200'
    return 'bg-gray-50 text-gray-600 border-gray-200'
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-extrabold font-display text-gray-900">Cases de Sucesso</h1>
        <Link to="/admin/cases/new" className="inline-flex items-center gap-2 rounded-lg bg-[#bef102] px-4 py-2 text-sm font-bold text-[#0d1f12] hover:bg-[#a8d800] transition-colors">
          <Plus size={16} /> Novo case
        </Link>
      </div>

      <div className="overflow-x-auto rounded-xl border border-gray-200 bg-white shadow-sm">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-gray-200 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">
              <th className="px-4 py-3">Título</th>
              <th className="px-4 py-3">Cliente</th>
              <th className="px-4 py-3">Setor</th>
              <th className="px-4 py-3">Status</th>
              <th className="px-4 py-3 text-right">Ações</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {loading ? (
              <tr><td colSpan={5} className="px-4 py-6 text-center text-gray-400">Carregando…</td></tr>
            ) : cases.length === 0 ? (
              <tr><td colSpan={5} className="px-4 py-6 text-center text-gray-400">Nenhum case cadastrado.</td></tr>
            ) : cases.map((c) => (
              <tr key={c.id} className="hover:bg-gray-50 transition-colors">
                <td className="px-4 py-3 text-gray-900 font-medium">{c.title}</td>
                <td className="px-4 py-3 text-gray-500">{c.client || '—'}</td>
                <td className="px-4 py-3 text-gray-500">{c.sector === 'public' ? 'Público' : 'Privado'}</td>
                <td className="px-4 py-3">
                  <span className={`inline-flex rounded-full px-2.5 py-0.5 text-xs font-semibold border ${statusBadge(c.status)}`}>
                    {c.status === 'published' ? 'Publicado' : 'Rascunho'}
                  </span>
                </td>
                <td className="px-4 py-3 text-right">
                  <div className="flex items-center justify-end gap-2">
                    <Link to={`/admin/cases/edit/${c.id}`} className="rounded-md p-1.5 text-gray-400 hover:bg-gray-100 hover:text-gray-900 transition-colors">
                      <Pencil size={15} />
                    </Link>
                    <button onClick={() => setDeleteId(c.id)} className="rounded-md p-1.5 text-gray-400 hover:bg-red-50 hover:text-red-600 transition-colors">
                      <Trash2 size={15} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <ConfirmModal open={!!deleteId} title="Excluir case" message="Tem certeza que deseja excluir este case? Esta ação não pode ser desfeita." onConfirm={handleDelete} onCancel={() => setDeleteId(null)} />
    </div>
  )
}
